module.exports = __webpack_public_path__ + "img/video.ffacddee.svg";